import { render, staticRenderFns } from "./AsignarExtensionCabina.vue?vue&type=template&id=5a05df94&"
import script from "./AsignarExtensionCabina.vue?vue&type=script&lang=js&"
export * from "./AsignarExtensionCabina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports